/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CreateAndUploadDocumentViewModel } from './CreateAndUploadDocumentViewModel';
import {
    CreateAndUploadDocumentViewModelFromJSON,
    CreateAndUploadDocumentViewModelFromJSONTyped,
    CreateAndUploadDocumentViewModelToJSON,
} from './CreateAndUploadDocumentViewModel';

/**
 * 
 * @export
 * @interface CreateAndUploadDocumentOrchestration
 */
export interface CreateAndUploadDocumentOrchestration {
    /**
     * 
     * @type {number}
     * @memberof CreateAndUploadDocumentOrchestration
     */
    proposalId: number;
    /**
     * 
     * @type {CreateAndUploadDocumentViewModel}
     * @memberof CreateAndUploadDocumentOrchestration
     */
    model: CreateAndUploadDocumentViewModel;
}

/**
 * Check if a given object implements the CreateAndUploadDocumentOrchestration interface.
 */
export function instanceOfCreateAndUploadDocumentOrchestration(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "proposalId" in value;
    isInstance = isInstance && "model" in value;

    return isInstance;
}

export function CreateAndUploadDocumentOrchestrationFromJSON(json: any): CreateAndUploadDocumentOrchestration {
    return CreateAndUploadDocumentOrchestrationFromJSONTyped(json, false);
}

export function CreateAndUploadDocumentOrchestrationFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateAndUploadDocumentOrchestration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'proposalId': json['ProposalId'],
        'model': CreateAndUploadDocumentViewModelFromJSON(json['Model']),
    };
}

export function CreateAndUploadDocumentOrchestrationToJSON(value?: CreateAndUploadDocumentOrchestration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ProposalId': value.proposalId,
        'Model': CreateAndUploadDocumentViewModelToJSON(value.model),
    };
}

